<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item prop="name">
        <el-input v-model="queryParams.name"  placeholder="群组名称" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="type" >
        <el-select v-model="queryParams.type" placeholder="请选择类型" style="width: 80%" >
          <el-option label="国家" value="local"></el-option>
          <el-option label="区域" value="region"></el-option>
          <el-option label="全球" value="global"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="hot" >
        <el-select v-model="queryParams.hot" placeholder="是否热门" style="width: 80%" >
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
      <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
    </el-form>
    <el-table v-loading="loading" :data="tableData" border>
      <el-table-column type="index" label="序号" align="center"></el-table-column>
      <el-table-column prop="name" label="群组名称" align="center"  :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="groupKey" label="群组编码" align="center" :show-overflow-tooltip="true"  ></el-table-column>
      <el-table-column prop="type" label="类型" align="center"  :show-overflow-tooltip="true"  >
        <template slot-scope="{row}">
          <el-tag v-if="row.type == 'local'" type="info">国家</el-tag>
          <el-tag v-else-if="row.type == 'region'">区域</el-tag>
          <el-tag v-else type="success">全球</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="countries" label="国家" align="center" width="500px">
          <template slot-scope="{row}">
            <div class="product-list" v-if="row.countries && row.countries.length > 0">
              <div class="product-item" v-for="(item,index) in row.countries.slice(0, 2)" :key="index" :title="item">
                    <span>{{item.name}}({{item.englishName}})</span>
              </div>
              <span class="el-dropdown-link" v-if="row.countries.length>2" @click="showMoreCountry(row)">
                <i class="el-icon-d-arrow-right el-icon--right"></i>更多
              </span>
            </div>
          </template>
      </el-table-column>
      <el-table-column prop="type" label="国际资源" align="center"  :show-overflow-tooltip="true" max-width="120"   >
        <template slot-scope="{row}">
          <el-tag style="margin-right: 6px;" v-for="(item,index) in row.channelList" :key="index" type="success">{{item.name}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" max-width="100" >
        <template slot-scope="{row}">
          <el-tag v-if="row.status == '1'" type="success">有效</el-tag>
          <el-tag v-else type="warning">无效</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right" >
        <template v-slot:default="{row}">
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <!-- 展示国家列表 -->
    <el-dialog title="国家列表" :visible.sync="moreCountryOpen" width="900px" append-to-body :close-on-click-modal="false">
      <el-input placeholder="请输入内容" v-model="searchQuery" clearable style="width: 30%"></el-input>
      <el-table :data="filteredTableData"  style="width: 100%;max-height:600px;overflow-y: auto;">
        <el-table-column prop="name" label="国家名称" align="center"></el-table-column>
        <el-table-column prop="englishName" label="英文名称" align="center"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 新增群组/修改 -->
    <el-dialog :title="title" :visible.sync="dialog" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="form" ref="form" :rules="rules"  label-width="140px">
        <el-form-item label="群组名称:" prop="name" >
          <el-input v-model="form.name" autocomplete="off" style="width: 80%" placeholder="请输入群组名称"></el-input>
        </el-form-item>
        <el-form-item label="群组英文名称:" prop="enName" >
          <el-input v-model="form.enName" autocomplete="off" style="width: 80%" placeholder="请输入群组英文名称"></el-input>
        </el-form-item>
        <el-form-item label="对外展示名称:" prop="showName" >
          <el-input v-model="form.showName" autocomplete="off" style="width: 80%" placeholder="对外展示名称"></el-input>
        </el-form-item>
        <el-form-item label="对外展示英文名称:" prop="enShowName" >
          <el-input v-model="form.enShowName" autocomplete="off" style="width: 80%" placeholder="对外展示英文名称"></el-input>
        </el-form-item>
        <el-form-item label="类型:" prop="type" >
           <el-select v-model="form.type" placeholder="请选择类型" style="width: 80%" :disabled="edit && form.type =='local'" >
            <el-option label="国家" value="local"></el-option>
            <el-option label="区域" value="region"></el-option>
            <el-option label="全球" value="global"></el-option>
           </el-select>
        </el-form-item>
        <el-form-item label="群组编码:" prop="groupKey" v-if="form.type !='local'">
          <el-input :disabled="edit" v-model="form.groupKey" autocomplete="off" style="width: 80%" placeholder="请输入群组编码"></el-input>
        </el-form-item>
        <el-form-item label="国家" prop="country" v-if="form.type =='local'">
          <el-select v-model="form.countryCode" placeholder="请选择国家" :disabled="edit">
            <el-option
                v-for="item in countryOptions"
                :key="item.countryCode"
                :label="item.name + '-' + item.channelNameStr"
                :value="item.countryCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国家" prop="country" v-if="form.type !='local'">
          <el-checkbox v-model="countryNodeAll" @change="handleCheckedTreeNodeAll($event)" >全选/全不选</el-checkbox>
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText" 
            style="width: 80%">
          </el-input>
          <el-tree
            style="width: 80%"
            class="tree-border"
            :data="countryOptions"
            show-checkbox
            ref="menu"
            node-key="countryCode"
            :filter-node-method="filterNode"
            empty-text="加载中，请稍候"
            :props="defaultProps"
          >
          <template #default="{ data }">
            <!-- 自定义节点展示内容 -->
            <span>{{ data.name }} - {{ data.channelNameStr }}</span>
          </template>
          </el-tree>
        </el-form-item>
        <el-form-item label="资源渠道:" prop="channels" >
          <el-select v-model="form.channels" filterable multiple  placeholder="请选择资源渠道" style="width:80%">
            <el-option
              v-for="item in channelData"
              :key="item.id"
              :label="item.name"
              :value="item.channel"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="网站图标:" prop="websiteIcon" >
          <el-input v-model="form.websiteIcon" autocomplete="off" style="width: 80%" placeholder="请输入网站展示图标"></el-input>
        </el-form-item>
        <el-form-item label="区域图片:" prop="websiteImage" >
          <el-input v-model="form.websiteImage" autocomplete="off" style="width: 80%" placeholder="请输入网站区域图片"></el-input>
        </el-form-item>
        <el-form-item label="H5图标:" prop="h5Icon" >
          <el-input v-model="form.h5Icon" autocomplete="off" style="width: 80%" placeholder="请输入H5展示图标"></el-input>
        </el-form-item>
        <el-form-item label="APP图标:" prop="appIcon" >
          <el-input v-model="form.appIcon" autocomplete="off" style="width: 80%" placeholder="请输入APP展示图标"></el-input>
        </el-form-item>
        <el-form-item label="介绍:" prop="description">
          <el-input type="textarea" v-model="form.description" autocomplete="off" style="width: 80%" placeholder="请输入区域介绍"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" v-model="form.remark" autocomplete="off" style="width: 80%" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="是否热门:" prop="hot">
          <el-radio-group v-model="form.hot">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancel">取消</el-button>
        <el-button type="success" @click="submit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { internationalGroupList , saveInternationalGroup , updateInternationalGroup , countryList , infoInternationalGroup} from "@/api/international.js";
import { listChannel } from "@/api/api.js";
export default {
  name: "internationalGroup",
  data() {
    let validateCountry = (rule, value, callback) => {
      if(this.form.type != 'local'){
        let checkedKeys = this.$refs.menu.getCheckedKeys();
        if (checkedKeys.length == 0) {
          callback(new Error('请选择国家'));
        } else {
          callback();
        }
      }else{
        callback();
      }
    }
    return {
      // 查询条件
      queryParams: {
        name:undefined,
        type:undefined,
      },
      channelData:[],
      edit:false,
      // 遮罩层
      loading: true,
      // 分页器
      page: 1,
      pageSize: 10,
      total: 10,
      // 列表数据
      tableData: [],
      moreCountryOpen:false,
      moreCountryData:[],
      searchQuery:'',
      title:"新增运营商",
      dialog:false,
      form:{
        id:undefined,
        name:undefined,
        enName:undefined,
        description:undefined,
        websiteImage:undefined,
        h5Icon:undefined,
        appIcon:undefined,
        websiteIcon:undefined,
        type:undefined,
        countryCodes:[],
        channels:[],
        showName:undefined,
        emShowName:undefined,
        remark:undefined,
        websiteIcon:undefined,
        hot:"0"
      },
      rules: {
        name: [
          { required: true, message: "群组名称不能为空", trigger: "blur" },
        ],
        groupKey: [
          { required: true, message: "群组编码不能为空", trigger: "blur" },
        ],
        type: [
          { required: true, message: "类型不能为空", trigger: "blur" },
        ],
        channels:[
          { required: true, message: "资源不能为空", trigger: "blur" },
        ],
        country:[
          { validator: validateCountry, trigger: "blur" },
        ]
      },
      filterText:'',
      defaultProps: {
        label: "name"
      },
      countryNodeAll:false,
      //国家列表
      countryOptions:[]
    };
  },
  computed: {
    filteredTableData() {
      return this.moreCountryData.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      });
    }
  },
  watch:{
    filterText(param){
      this.$refs.menu.filter(param);
    } 
  },
  methods: {
    showMoreCountry(item){
      this.moreCountryOpen = true
      this.moreCountryData = item.countries
    },
    initChannel(){
      let operatorId = '4'
      listChannel({operatorId}).then(res=>{
        this.channelData = res.data.data
      })
    },
    // 添加
    handleAdd() {
      this.title = "新增群组"
      this.dialog = true
      this.edit = false
      this.selectCountrys()
      this.form ={
        id:undefined,
        remark:undefined
      }
    },
    // 编辑
    handleEdit(row){
        this.dialog = true
        this.title = "修改群组"
        this.selectCountrys()
        let id = row.id
        infoInternationalGroup({id}).then(res=>{
          this.edit = true
          this.form = res.data.data
          this.form.countryCode = this.form.groupKey
          if(this.form.type !='local' && this.form.countries && this.form.countries.length > 0){
            this.$nextTick(() => {
              const checkedKeys = this.form.countries.map(country => country.countryCode);
              if(checkedKeys.length>0 && this.countryOptions.length == checkedKeys.length){
                this.countryNodeAll = true
              }
              checkedKeys.forEach((v) => {
                  this.$nextTick(()=>{
                      this.$refs.menu.setChecked(v, true ,false);
                  })
                })
            });
          }
        })
    },

    // 搜索
    handleSearch() {
      this.initData();
    },
    // 获取列表
    initData() {
      this.loading=true;
      let params = {
        model:{
          ...this.queryParams
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      internationalGroupList(params).then(res => {
        this.loading=false;
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    cancel(){
        this.dialog= false
        this.resetForm("form");
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    submit(){
      this.$refs.form.validate(valid => {
        if (valid) {
            this.form.countryCodes = this.getMenuAllCheckedKeys();
            if(!!this.form.id){
                updateInternationalGroup(this.form).then(res=>{
                    this.cancel()
                    this.initData()
                })
            }else{
                saveInternationalGroup(this.form).then(res=>{
                    this.cancel()
                    this.initData()
                })
            }
        }
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value) {
      this.$refs.menu.setCheckedNodes(value ? this.countryOptions: []);
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      if(!this.$refs.menu){
        return null;
      }
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.menu.getCheckedKeys();
      return checkedKeys;
    },
    selectCountrys(){
      countryList().then(res=>{
        this.countryOptions = res.data.data
      })
    }
  },
  mounted() {

  },
  created() {
    this.initChannel()
    this.initData()
  },
};
</script>
<style scoped lang="less">
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 600px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 180px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}
/deep/.tree-border {
  max-height: 32vh; /* 最大高度为视口高度的70%，可根据需求调整 */
  overflow-y: auto; /* 超出时显示垂直滚动条 */
  padding-top: 15px; /* 可选：调整内边距，优化布局 */
}

/deep/.tree-border::-webkit-scrollbar {
  width: 6px;
}
/deep/.tree-border::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
</style>
